import { Grid } from "@material-ui/core";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Loader } from "../../components/loader";
import { NullablePartial } from "../../utils/utils";
import { useFetchable } from "../../store/common/fetchable";
import { UsersDTO } from "../../store/users/models/dto";
import { Users } from "../../store/users/reducer";
import { VerificationDTO } from "../../store/verification/models/dto/kyc";
import { Verification } from "../../store/verification/reducer";
import { PresentationalAllSelfKyc } from "./all-self-kyc";
import { GeneralInfo } from "./general-info";
import { KycVerificationPage } from "./kyc-verification";
import { Pageable } from "../../services/pageable";
import { PresentationalAllKycDocuments } from "./all-kyc-documents";
import BN from "bn.js";
import { useBrowserWallet } from "../../store/wallets/crypto";
import { StakeContext } from "../staking/single/context";
import { partition } from "lodash";
import { Wallets } from "../../store/wallets/reducer";
import { Fetchable, isFetchableSuccess } from "../../store/common/fetchable/helpers";
import { Option } from "space-monad";
export const ProfilePage = () => {
  const currentUser = useFetchable(Users.current);
  const allSelfKyc = useFetchable(
    Verification.allSelfKyc,
    useMemo<Pageable.T<"userStatus" | "createdDate">>(
      () => ({
        pagination: {
          size: 5,
          page: 0,
        },
        sorting: {
          direction: "desc",
          field: "createdDate",
        },
      }),
      []
    )
  );

  return (
    <Loader<
      UsersDTO.Responses.GetSingle.T | VerificationDTO.Responses.GetAllKyc.T
    >
      data={[currentUser, allSelfKyc]}
    >
      {([loadedCurrentUser, loadedAllSelfKyc]) => (
        <ProfileForm
          allSelfKyc={loadedAllSelfKyc as VerificationDTO.Responses.GetAllKyc.T}
          currentUser={loadedCurrentUser as UsersDTO.Responses.GetSingle.T}
        />
      )}
    </Loader>
  );
};

const ProfileForm: React.FunctionComponent<{
  currentUser: NullablePartial<UsersDTO.Requests.UserDetails.T>;
  allSelfKyc: VerificationDTO.Responses.GetAllKyc.T;
}> = ({ currentUser, allSelfKyc }) => {
  const currentUser1 = useFetchable(Users.current);
  const hundredThousand = new BN('152D02C7E14AF6800000', 16);
  const zero = new BN('0', 16);
  const [flag, setFlag] = useState<boolean>(false);
  const {
    connect,
    verify,
    state,
    balance,
    accounts,
    // isVerified,
  } = useBrowserWallet();
  const { allContracts } = useContext(StakeContext);

  const allContractsResult = useMemo(
    () => allContracts.map((x) => partition(x, (y) => y.stakingAllowed)),
    [allContracts]
  );
  const totalStakedbalance = useFetchable(Wallets.totalBalance);

  useEffect(() => {

    accounts.fold(
      () => (
        setFlag(false)
      ), () => (
        Option.all([balance, accounts]).fold(
          () => null,
          ([b, a]) => (
            setFlag(b.amount.gte(hundredThousand))
          )
        )
      ))

    if (isFetchableSuccess(totalStakedbalance)) {
      if (totalStakedbalance.data) {
        if (!flag) {
          setFlag(totalStakedbalance.data >= 100000)
        }
      }
    }

    if (isFetchableSuccess(currentUser1)) {
      if (currentUser1.data.payingSubscriber) {
        setFlag(true)
      }
    }

  }, [balance, accounts, allContractsResult, state, currentUser1]);
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <GeneralInfo userDetails={currentUser} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <KycVerificationPage />
          </Grid>
          <Grid item xs={12}>
            <PresentationalAllSelfKyc allSelfKyc={allSelfKyc} />
          </Grid>
          {flag &&
            <Grid item xs={12}>
              <PresentationalAllKycDocuments userDetails={currentUser} />
            </Grid>}
        </Grid>
      </Grid>
    </Grid>
  );
};
